'use client';

import { use, useEffect } from 'react';

import type { BookingDataPatch } from '../_lib/server/booking-page.loader';

export function BookingDataStream({ promise, onResolve }: {
  promise: Promise<BookingDataPatch>;
  onResolve: (data: BookingDataPatch) => void;
}) {
  const data = use(promise);
  // Publish streamed server data after commit, without suspending or remounting
  // the interactive form that contains this boundary.
  useEffect(() => { onResolve(data); }, [data, onResolve]);
  return null;
}
